import { render, staticRenderFns } from "./investmentInstitutions.vue?vue&type=template&id=130ef298&scoped=true&"
import script from "./investmentInstitutions.vue?vue&type=script&lang=js&"
export * from "./investmentInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./investmentInstitutions.vue?vue&type=style&index=0&id=130ef298&prod&scoped=true&lang=css&"
import style1 from "./investmentInstitutions.vue?vue&type=style&index=1&id=130ef298&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ef298",
  null
  
)

export default component.exports